/* eslint-disable */
// This is a generated file. Any changes you make here will be lost once it's re-generated.
// The shape mirrors Gamefound.Web.MainApplication.Models.ScriptInitConfigModel - change it there, not here.

/**
 * @typedef {Object} ApiSiteFeaturesModel
 * @property {boolean} exportEnabled
 * @property {boolean} importEnabled
 */

/**
 * @typedef {Object} ScriptInitCdnTransformationModel
 * @property {boolean} enabled
 * @property {Object} transformations
 */

/**
 * @typedef {Object} ScriptInitCommentsModel
 * @property {string} tagPattern
 */

/**
 * @typedef {Object} ScriptInitCurrentUserModel
 * @property {boolean} hasAccessToAdminMode
 */

/**
 * @typedef {Object} ScriptInitExternalScriptsModel
 * @property {string} googlePayUrl
 * @property {string} applePayUrl
 * @property {string} googleSignInUrl
 * @property {string} facebookSignInUrl
 * @property {string} reCaptchaUrl
 * @property {string} stripeScriptUrl
 * @property {string} youTubeApiScriptUrl
 * @property {string} appleSignInUrl
 */

/**
 * @typedef {Object} ScriptInitExternalUrlsModel
 * @property {string} careerUrl
 * @property {string} creatingRewardsInCrowdfundingArticle
 * @property {string} dynamicCurrencyConversionArticleUrl
 * @property {string} enterpriseSolutionsUrl
 * @property {string} forRetailersUrl
 * @property {string} gamefoundBecomeACreatorUrl
 * @property {string} helpUrl
 * @property {string} performanceMarketingCampaignStatisticsHelpUrl
 * @property {string} performanceMarketingPreparingAssetsHelpUrl
 * @property {string} performanceMarketingCatalogCampaignFeesHelpUrl
 * @property {string} digitalServiceTaxLearnMoreUrl
 * @property {string} projectDetailedDescriptionArticle
 * @property {string} stablePledgeInformationBackerHelpUrl
 * @property {string} stablePledgeInformationCreatorHelpUrl
 * @property {string} stablePledgeSecureYourPledgeArticleUrl
 * @property {string} shippingGuideArticleUrl
 * @property {string} reCaptchaPrivacyPolicyUrl
 * @property {string} reCaptchaTermsUrl
 */

/**
 * @typedef {Object} ScriptInitPlatformBrandingSocialMediaUrlsModel
 * @property {string} facebookUrl
 * @property {string} instagramUrl
 * @property {string} xUrl
 * @property {string} youTubeUrl
 * @property {string} linkedInUrl
 */

/**
 * @typedef {Object} ScriptInitContactModel
 * @property {string} joinUsMail
 * @property {string} authoritiesMail
 * @property {string} officialPhoneNumber
 * @property {string} businessMail
 */

/**
 * @typedef {Object} ScriptInitHttpModel
 * @property {string} root
 * @property {string} performanceMarketing
 */

/**
 * @typedef {Object} ScriptInitLanguageConfigModel
 * @property {string} currentLanguageIsoCode
 * @property {boolean} languageSelectorEnabled
 */

/**
 * @typedef {Object} ScriptInitPlatformUrlsModel
 * @property {string} aboutUsUrl
 * @property {string} accountSettingsUrl
 * @property {string} adminUrl
 * @property {string} backerCenterDashboardUrl
 * @property {string} backerCenterGiftCardsUrl
 * @property {string} backerCenterPaymentsUrl
 * @property {string} backerCenterPledgesAndOrdersUrl
 * @property {string} backerCenterUpdatesUrl
 * @property {string} backerCenterYourProjectsUrl
 * @property {string} backersTermsOfServiceUrl
 * @property {string} becomeACreatorUrl
 * @property {string} blogUrl
 * @property {string} communityGuidelinesUrl
 * @property {string} contactTranslationUrl
 * @property {string} contactUrl
 * @property {string} contentPolicyUrl
 * @property {string} cookieSettingsUrl
 * @property {string} createAccountUrl
 * @property {string} createAccountUrlWithReturn
 * @property {string} createCreatorAccountUrl
 * @property {string} creatorDataProcessingAgreementUrl
 * @property {string} creatorDigitalTermsOfServiceUrl
 * @property {string} creatorProblemBusinessContactUrl
 * @property {string} creatorTermsOfServiceUrl
 * @property {string} crowdfundingGuideUrl
 * @property {string} currentActionUrl
 * @property {string} digitalContentTermsOfServiceUrl
 * @property {string} feesUrl
 * @property {string} homeUrl
 * @property {string} intellectualPropertyPolicyUrl
 * @property {string} joinCallbackUrl
 * @property {string} joinProjectUrl
 * @property {string} loginUrl
 * @property {string} loginUrlWithReturn
 * @property {string} logoutUrl
 * @property {string} marketingServicesUrl
 * @property {string} partnerNetworkContactUrl
 * @property {string} partnerNetworkPrivacyPolicyUrl
 * @property {string} partnerNetworkTermsUrl
 * @property {string} partnerNetworkUrl
 * @property {string} performResetPasswordUrl
 * @property {string} performanceMarketingTermsOfServiceUrl
 * @property {string} performanceMarketingUrl
 * @property {string} pledgeManagerInfoUrl
 * @property {string} privacyPolicyUrl
 * @property {string} reservedFundsPolicyUrl
 * @property {string} resetPasswordRequestSentUrl
 * @property {string} resetPasswordUrl
 * @property {string} retailerProgramPrivacyPolicyUrl
 * @property {string} retailerProgramTermsUrl
 * @property {string} searchUrl
 * @property {string} storesTermsOfServiceUrl
 * @property {string} subscriptionManagementUrl
 * @property {string} termsOfServiceIndexUrl
 * @property {string} termsOfServiceUrl
 * @property {string} trademarkPolicyUrl
 * @property {string} userProfileUrl
 * @property {string} whyGamefoundUrl
 */

/**
 * @typedef {Object} ScriptInitOrderRules
 * @property {Object[]} availableOrderStagesForCreatorChange
 * @property {Object[]} orderPaymentStatusesForCrowdfundingFilters
 * @property {Object[]} orderPaymentStatusesForExternalPMFilters
 * @property {Object[]} orderPaymentStatusesForPreorderFilters
 * @property {Object[]} orderPaymentStatusesForStoreFilters
 * @property {Object[]} orderPaymentStatusesForV1ProjectFilters
 * @property {Object[]} orderStagesForCrowdfundingFilters
 * @property {Object[]} orderStagesForExternalPMFilters
 * @property {Object[]} orderStagesForPreorderFilters
 * @property {Object[]} orderStagesForStoreFilters
 * @property {Object[]} orderStagesForV1ProjectFilters
 */

/**
 * @typedef {Object} ScriptInitPaymentProvidersConfigModel
 * @property {?ScriptInitPaymentProvidersConfigModelAdyenConfigModel} adyen
 * @property {?ScriptInitPaymentProvidersConfigModelGooglePayConfigModel} googlePay
 * @property {?ScriptInitPaymentProvidersConfigModelApplePayConfigModel} applePay
 * @property {?ScriptInitPaymentProvidersConfigModelStripeConfigModel} stripe
 */

/**
 * @typedef {Object} ScriptInitPlatformContactAddressesModel
 * @property {string} complianceContactAddress
 * @property {string} financeContactAddress
 */

/**
 * @typedef {Object} ScriptInitProjectUrlsModel
 * @property {string} backProjectUrl
 * @property {string} checkoutUrl
 * @property {string} customTosUrl
 * @property {string} creatorUrl
 * @property {string} changeCurrencyUrl
 * @property {string} originalCampaignUrl
 * @property {string} projectContactUrl
 * @property {string} projectHome
 * @property {string} refundAndCancellationPolicyUrl
 * @property {string} stretchGoalsUrl
 * @property {string} yourPledgeUrl
 */

/**
 * @typedef {Object} ScriptInitProjectNavigationNamesModel
 * @property {string} refundAndCancellationPolicyName
 */

/**
 * @typedef {Object} ScriptInitProjectRankingsModel
 * @property {number[]} visibleTimeSpans
 * @property {?number} rankingsDefaultCategory
 * @property {boolean} rankingsEnabled
 */

/**
 * @typedef {Object} ScriptInitPushNotificationsConfigModel
 * @property {string} apiKey
 * @property {string} appID
 * @property {string} authDomain
 * @property {string} messagingSenderID
 * @property {string} projectID
 * @property {string} storageBucket
 * @property {string} vapidKey
 */

/**
 * @typedef {Object} ScriptInitReCaptchaConfigModel
 * @property {string} siteKey
 * @property {boolean} isEnabled
 */

/**
 * @typedef {Object} ScriptInitIdentityProvidersConfigModel
 * @property {?FacebookSignInConfigModel} facebook
 * @property {?GoogleSignInConfigModel} google
 * @property {?AppleSignInConfigModel} apple
 */

/**
 * @typedef {Object} ScriptInitSiteFeaturesModel
 * @property {boolean} performanceMarketingEnabled
 * @property {boolean} feastNewsletterEnabled
 * @property {boolean} transcendIntegrationEnabled
 * @property {boolean} legalComplianceEnabled
 * @property {boolean} performanceMarketingVisibleToAdminsEnabled
 * @property {boolean} partnerNetworkEnabled
 */

/**
 * @typedef {Object} ScriptInitGlobalProjectSettingsModel
 * @property {number} postCrowdfundingPhaseEarlyLaunchDelayInDays
 * @property {number} postCrowdfundingPhaseLaunchDelayInDays
 */

/**
 * @typedef {Object} ClientCultureInfo
 * @property {string} name
 * @property {?DateTimeFormatInfo} dateTimeFormat
 * @property {?NumberFormatInfo} numberFormat
 */

/**
 * @typedef {Object} ScriptInitPaymentProvidersConfigModelAdyenConfigModel
 * @property {string} clientKey
 * @property {string} gatewayMerchantId
 * @property {string} merchantName
 * @property {boolean} useLiveMode
 * @property {string[]} availableCardBrands
 * @property {number[]} pwaIosBlockedPaymentMethods
 */

/**
 * @typedef {Object} ScriptInitPaymentProvidersConfigModelGooglePayConfigModel
 * @property {string} merchantId
 * @property {boolean} isEnabled
 */

/**
 * @typedef {Object} ScriptInitPaymentProvidersConfigModelApplePayConfigModel
 * @property {boolean} isEnabled
 */

/**
 * @typedef {Object} ScriptInitPaymentProvidersConfigModelStripeConfigModel
 * @property {string} publishable
 */

/**
 * @typedef {Object} FacebookSignInConfigModel
 * @property {string} appID
 * @property {boolean} isEnabled
 */

/**
 * @typedef {Object} GoogleSignInConfigModel
 * @property {string} clientID
 * @property {boolean} isEnabled
 */

/**
 * @typedef {Object} AppleSignInConfigModel
 * @property {string} clientID
 * @property {boolean} isEnabled
 * @property {string} redirectUrl
 */

/**
 * @typedef {Object} DateTimeFormatInfo
 * @property {string} amDesignator
 * @property {?Calendar} calendar
 * @property {string} dateSeparator
 * @property {number} firstDayOfWeek
 * @property {number} calendarWeekRule
 * @property {string} fullDateTimePattern
 * @property {string} longDatePattern
 * @property {string} longTimePattern
 * @property {string} monthDayPattern
 * @property {string} pmDesignator
 * @property {string} rfC1123Pattern
 * @property {string} shortDatePattern
 * @property {string} shortTimePattern
 * @property {string} sortableDateTimePattern
 * @property {string} timeSeparator
 * @property {string} universalSortableDateTimePattern
 * @property {string} yearMonthPattern
 * @property {Object[]} abbreviatedDayNames
 * @property {Object[]} shortestDayNames
 * @property {Object[]} dayNames
 * @property {Object[]} abbreviatedMonthNames
 * @property {Object[]} monthNames
 * @property {boolean} isReadOnly
 * @property {string} nativeCalendarName
 * @property {Object[]} abbreviatedMonthGenitiveNames
 * @property {Object[]} monthGenitiveNames
 */

/**
 * @typedef {Object} NumberFormatInfo
 * @property {number} currencyDecimalDigits
 * @property {string} currencyDecimalSeparator
 * @property {boolean} isReadOnly
 * @property {Object[]} currencyGroupSizes
 * @property {Object[]} numberGroupSizes
 * @property {Object[]} percentGroupSizes
 * @property {string} currencyGroupSeparator
 * @property {string} currencySymbol
 * @property {string} naNSymbol
 * @property {number} currencyNegativePattern
 * @property {number} numberNegativePattern
 * @property {number} percentPositivePattern
 * @property {number} percentNegativePattern
 * @property {string} negativeInfinitySymbol
 * @property {string} negativeSign
 * @property {number} numberDecimalDigits
 * @property {string} numberDecimalSeparator
 * @property {string} numberGroupSeparator
 * @property {number} currencyPositivePattern
 * @property {string} positiveInfinitySymbol
 * @property {string} positiveSign
 * @property {number} percentDecimalDigits
 * @property {string} percentDecimalSeparator
 * @property {string} percentGroupSeparator
 * @property {string} percentSymbol
 * @property {string} perMilleSymbol
 * @property {Object[]} nativeDigits
 * @property {number} digitSubstitution
 */

/**
 * @typedef {Object} Calendar
 * @property {string} minSupportedDateTime
 * @property {string} maxSupportedDateTime
 * @property {number} algorithmType
 * @property {boolean} isReadOnly
 * @property {Object[]} eras
 * @property {number} twoDigitYearMax
 */

/**
 * @typedef {Object} Config
 * @property {?ApiSiteFeaturesModel} admin
 * @property {string} antiForgeryTokenKey
 * @property {?ScriptInitCdnTransformationModel} cdn
 * @property {?ScriptInitCommentsModel} comments
 * @property {?ScriptInitCurrentUserModel} currentUser
 * @property {boolean} debug
 * @property {string} environment
 * @property {boolean} externalPMV2Enabled
 * @property {?ScriptInitExternalScriptsModel} externalScripts
 * @property {?ScriptInitExternalUrlsModel} externalUrls
 * @property {?ScriptInitPlatformBrandingSocialMediaUrlsModel} socialMediaUrls
 * @property {?ScriptInitContactModel} contact
 * @property {number} platform
 * @property {string} platformName
 * @property {?ScriptInitHttpModel} http
 * @property {?ScriptInitLanguageConfigModel} language
 * @property {?ScriptInitPlatformUrlsModel} navigation
 * @property {?ScriptInitOrderRules} orderRules
 * @property {?ScriptInitPaymentProvidersConfigModel} paymentProviders
 * @property {?ScriptInitPlatformContactAddressesModel} platformContactAddresses
 * @property {?ScriptInitProjectUrlsModel} projectNavigation
 * @property {?ScriptInitProjectNavigationNamesModel} projectNavigationNames
 * @property {?ScriptInitProjectRankingsModel} projectRankings
 * @property {?ScriptInitPushNotificationsConfigModel} pushNotifications
 * @property {?ScriptInitReCaptchaConfigModel} reCaptchaProvider
 * @property {string} siteTitle
 * @property {string} serverDate
 * @property {?ScriptInitIdentityProvidersConfigModel} userIdentityProviders
 * @property {?ScriptInitSiteFeaturesModel} siteFeatures
 * @property {?ScriptInitGlobalProjectSettingsModel} globalProjectSettings
 * @property {?ClientCultureInfo} clientCultureInfo
 */

const defaults = {
    admin: {"exportEnabled":false,"importEnabled":false},
    antiForgeryTokenKey: null,
    cdn: {"enabled":false,"transformations":{}},
    comments: {"tagPattern":null},
    currentUser: {"hasAccessToAdminMode":false},
    debug: false,
    environment: null,
    externalPMV2Enabled: false,
    externalScripts: {"googlePayUrl":null,"applePayUrl":null,"googleSignInUrl":null,"facebookSignInUrl":null,"reCaptchaUrl":null,"stripeScriptUrl":null,"youTubeApiScriptUrl":null,"appleSignInUrl":null},
    externalUrls: {"careerUrl":null,"creatingRewardsInCrowdfundingArticle":null,"dynamicCurrencyConversionArticleUrl":null,"enterpriseSolutionsUrl":null,"forRetailersUrl":null,"gamefoundBecomeACreatorUrl":null,"helpUrl":null,"performanceMarketingCampaignStatisticsHelpUrl":null,"performanceMarketingPreparingAssetsHelpUrl":null,"performanceMarketingCatalogCampaignFeesHelpUrl":null,"digitalServiceTaxLearnMoreUrl":null,"projectDetailedDescriptionArticle":null,"stablePledgeInformationBackerHelpUrl":null,"stablePledgeInformationCreatorHelpUrl":null,"stablePledgeSecureYourPledgeArticleUrl":null,"shippingGuideArticleUrl":null,"reCaptchaPrivacyPolicyUrl":null,"reCaptchaTermsUrl":null},
    socialMediaUrls: {"facebookUrl":null,"instagramUrl":null,"xUrl":null,"youTubeUrl":null,"linkedInUrl":null},
    contact: {"joinUsMail":null,"authoritiesMail":null,"officialPhoneNumber":null,"businessMail":null},
    platform: 0,
    platformName: null,
    http: {"root":null,"performanceMarketing":null},
    language: {"currentLanguageIsoCode":null,"languageSelectorEnabled":false},
    navigation: {"aboutUsUrl":null,"accountSettingsUrl":null,"adminUrl":null,"backerCenterDashboardUrl":null,"backerCenterGiftCardsUrl":null,"backerCenterPaymentsUrl":null,"backerCenterPledgesAndOrdersUrl":null,"backerCenterUpdatesUrl":null,"backerCenterYourProjectsUrl":null,"backersTermsOfServiceUrl":null,"becomeACreatorUrl":null,"blogUrl":null,"communityGuidelinesUrl":null,"contactTranslationUrl":null,"contactUrl":null,"contentPolicyUrl":null,"cookieSettingsUrl":null,"createAccountUrl":null,"createAccountUrlWithReturn":null,"createCreatorAccountUrl":null,"creatorDataProcessingAgreementUrl":null,"creatorDigitalTermsOfServiceUrl":null,"creatorProblemBusinessContactUrl":null,"creatorTermsOfServiceUrl":null,"crowdfundingGuideUrl":null,"currentActionUrl":null,"digitalContentTermsOfServiceUrl":null,"feesUrl":null,"homeUrl":null,"intellectualPropertyPolicyUrl":null,"joinCallbackUrl":null,"joinProjectUrl":null,"loginUrl":null,"loginUrlWithReturn":null,"logoutUrl":null,"marketingServicesUrl":null,"partnerNetworkContactUrl":null,"partnerNetworkPrivacyPolicyUrl":null,"partnerNetworkTermsUrl":null,"partnerNetworkUrl":null,"performResetPasswordUrl":null,"performanceMarketingTermsOfServiceUrl":null,"performanceMarketingUrl":null,"pledgeManagerInfoUrl":null,"privacyPolicyUrl":null,"reservedFundsPolicyUrl":null,"resetPasswordRequestSentUrl":null,"resetPasswordUrl":null,"retailerProgramPrivacyPolicyUrl":null,"retailerProgramTermsUrl":null,"searchUrl":null,"storesTermsOfServiceUrl":null,"subscriptionManagementUrl":null,"termsOfServiceIndexUrl":null,"termsOfServiceUrl":null,"trademarkPolicyUrl":null,"userProfileUrl":null,"whyGamefoundUrl":null},
    orderRules: {"availableOrderStagesForCreatorChange":[],"orderPaymentStatusesForCrowdfundingFilters":[],"orderPaymentStatusesForExternalPMFilters":[],"orderPaymentStatusesForPreorderFilters":[],"orderPaymentStatusesForStoreFilters":[],"orderPaymentStatusesForV1ProjectFilters":[],"orderStagesForCrowdfundingFilters":[],"orderStagesForExternalPMFilters":[],"orderStagesForPreorderFilters":[],"orderStagesForStoreFilters":[],"orderStagesForV1ProjectFilters":[]},
    paymentProviders: {"adyen":{"clientKey":null,"gatewayMerchantId":null,"merchantName":null,"useLiveMode":false,"availableCardBrands":[],"pwaIosBlockedPaymentMethods":[]},"googlePay":{"merchantId":null,"isEnabled":false},"applePay":{"isEnabled":false},"stripe":{"publishable":null}},
    platformContactAddresses: {"complianceContactAddress":null,"financeContactAddress":null},
    projectNavigation: {"backProjectUrl":null,"checkoutUrl":null,"customTosUrl":null,"creatorUrl":null,"changeCurrencyUrl":null,"originalCampaignUrl":null,"projectContactUrl":null,"projectHome":null,"refundAndCancellationPolicyUrl":null,"stretchGoalsUrl":null,"yourPledgeUrl":null},
    projectNavigationNames: {"refundAndCancellationPolicyName":null},
    projectRankings: {"visibleTimeSpans":[],"rankingsDefaultCategory":null,"rankingsEnabled":false},
    pushNotifications: {"apiKey":null,"appID":null,"authDomain":null,"messagingSenderID":null,"projectID":null,"storageBucket":null,"vapidKey":null},
    reCaptchaProvider: {"siteKey":null,"isEnabled":false},
    siteTitle: null,
    serverDate: null,
    userIdentityProviders: {"facebook":{"appID":null,"isEnabled":false},"google":{"clientID":null,"isEnabled":false},"apple":{"clientID":null,"isEnabled":false,"redirectUrl":null}},
    siteFeatures: {"performanceMarketingEnabled":false,"feastNewsletterEnabled":false,"transcendIntegrationEnabled":false,"legalComplianceEnabled":false,"performanceMarketingVisibleToAdminsEnabled":false,"partnerNetworkEnabled":false},
    globalProjectSettings: {"postCrowdfundingPhaseEarlyLaunchDelayInDays":0,"postCrowdfundingPhaseLaunchDelayInDays":0},
    clientCultureInfo: null,
};

/** @type {Config} */
const config = window.__CONFIG__ ?? defaults;

export default config;
export const admin = config.admin;
export const antiForgeryTokenKey = config.antiForgeryTokenKey;
export const cdn = config.cdn;
export const comments = config.comments;
export const currentUser = config.currentUser;
export const debug = config.debug;
export const environment = config.environment;
export const externalPMV2Enabled = config.externalPMV2Enabled;
export const externalScripts = config.externalScripts;
export const externalUrls = config.externalUrls;
export const socialMediaUrls = config.socialMediaUrls;
export const contact = config.contact;
export const platform = config.platform;
export const platformName = config.platformName;
export const http = config.http;
export const language = config.language;
export const navigation = config.navigation;
export const orderRules = config.orderRules;
export const paymentProviders = config.paymentProviders;
export const platformContactAddresses = config.platformContactAddresses;
export const projectNavigation = config.projectNavigation;
export const projectNavigationNames = config.projectNavigationNames;
export const projectRankings = config.projectRankings;
export const pushNotifications = config.pushNotifications;
export const reCaptchaProvider = config.reCaptchaProvider;
export const siteTitle = config.siteTitle;
export const serverDate = config.serverDate;
export const userIdentityProviders = config.userIdentityProviders;
export const siteFeatures = config.siteFeatures;
export const globalProjectSettings = config.globalProjectSettings;
export const clientCultureInfo = config.clientCultureInfo;
